export class OTA_PaymentCard {
    public cardType: number;
    public cardCode: string;
    public cardNumber: string;
    public maskedCardNumber: string;
    public expireDate: string;
    public cardHolderName: string;
}
